import { render, staticRenderFns } from "./PostRequirement.vue?vue&type=template&id=d94af852&scoped=true&"
import script from "./PostRequirement.vue?vue&type=script&lang=js&"
export * from "./PostRequirement.vue?vue&type=script&lang=js&"
import style0 from "./PostRequirement.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PostRequirement.vue?vue&type=style&index=1&id=d94af852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94af852",
  null
  
)

export default component.exports